(function () {

    'use strict';

    angular.module('iplusjs.utils.money', [
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.utils.format'
    ])
    .service('MoneyUtilsService', MoneyUtilsService);

    MoneyUtilsService.$inject = [
        '$log',
        'lodash',
        'FormatUtilsService',
        'MiscUtilsService'
    ];
    function MoneyUtilsService($log, _, FormatUtilsService, MiscUtilsService) {
        var that = this,
            currencies = {
                EUR: {
                    code: 'EUR',
                    symbol: '€'
                },
                MARK: {
                    code: 'MRK',
                    symbol: 'Mark'
                }
            },
            currencyTemplate = _.template('<%= currency %>');

        that.isMoneyObject = isMoneyObject;
        that.getAmount = getAmount;
        that.toMoneyObject = toMoneyObject;
        that.toMoneyString = toMoneyString;
        that.summation = summation;
        function isMoneyObject(value) {
            return _.isObject(value) && value.hasOwnProperty('amount') && value.hasOwnProperty('currency');
        }
        function getAmount(money) {
            money = money || {};
            return parseFloat(money.amount);
        }
        function toMoneyObject(value, currency) {
            var amount = value,
                precision;

            if (!_.isString(amount) && !_.isNumber(amount)) {
                return null;
            }

            if (_.isNaN(parseFloat(amount))) {
                return null;
            }

            currency = currency || 'EUR';
            precision = _.size(_.toString(amount).split('.')[1]);

            if (precision < 2) {
                amount = parseFloat(amount).toFixed(2);
            }

            return {
                amount: _.toString(amount),
                currency: currencies[currency]
            };
        }
        function toMoneyString(money, options) {
            options = options || {};

            if (!isMoneyObject(money)) {
                return '';
            }

            options.decimal = MiscUtilsService.isEmpty(options.decimal) ? 2 : options.decimal;
            options.currencyPosition = options.currencyPosition || '+';
            options.currency = options.currency || 'symbol';
            options.showFractionsOnlyIfExists = options.showFractionsOnlyIfExists || false;

            if (_.toNumber(getAmount(money)) === 0 && MiscUtilsService.isNotEmpty(options.zeroMoneySubstitution) && !options.zeroMoneySubstitutionOnlyForEmpty) {
                return options.zeroMoneySubstitution;
            }

            if (MiscUtilsService.isEmpty(money) && MiscUtilsService.isNotEmpty(options.zeroMoneySubstitution) && options.zeroMoneySubstitutionOnlyForEmpty) {
                return options.zeroMoneySubstitution;
            }

            return FormatUtilsService.formatNumber(getAmount(money), {
                decimal: options.decimal,
                textPosition: options.currencyPosition,
                showFractionsOnlyIfExists: options.showFractionsOnlyIfExists,
                text: currencyTemplate({
                    currency: _.get(money, ['currency', options.currency].join('.'))
                })
            });
        }
        function summation() {
            var moneyValues = Array.prototype.slice.call(arguments),
                idx, len,
                sum,
                currencyCode;

            if (MiscUtilsService.isNotEmpty(moneyValues) && _.uniqBy(arguments, 'currency.code').length > 1) {
                $log.warn('Different currencies can not be added!');
                return toMoneyObject(sum);
            }

            for (idx = 0, len = moneyValues.length; idx < len; idx++) {
                if (!isMoneyObject(moneyValues[idx])) {
                    continue;
                }

                sum = sum || 0;

                if (!currencyCode) {
                    currencyCode = _.get(moneyValues[idx], 'currency.code');
                }

                sum += getAmount(moneyValues[idx]);
            }

            return toMoneyObject(sum, currencyCode);
        }
    }

})();
